var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#CF3126"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12681 14.628L10.5127 5.88048C11.1276 4.65401 12.8782 4.65433 13.4927 5.88103L17.8745 14.6285C18.4297 15.7368 17.6239 17.0417 16.3844 17.0417H7.6167C6.37692 17.0417 5.57114 15.7363 6.12681 14.628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33334V11",
    stroke: "#CF3126",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4166 14.3333C12.4166 14.5634 12.2301 14.75 12 14.75C11.7699 14.75 11.5833 14.5634 11.5833 14.3333C11.5833 14.1032 11.7699 13.9167 12 13.9167C12.2301 13.9167 12.4166 14.1032 12.4166 14.3333Z",
    stroke: "#CF3126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warningCircle.eb44d279ee455cbef6a2d38c4cb3b478.svg";
export { ForwardRef as ReactComponent };